import { KeyRound, LockKeyhole } from 'lucide-react';
import { useState } from 'react';

export default function LoginScreen({ initialKey = '', onEnter, busy, error }) {
  const [key, setKey] = useState(initialKey);
  const [remember, setRemember] = useState(Boolean(initialKey));

  function submit(event) {
    event.preventDefault();
    onEnter(key.trim(), remember);
  }

  return (
    <main className="login-shell">
      <section className="login-panel" aria-labelledby="login-title">
        <div className="brand-mark" aria-hidden="true"><span>小</span></div>
        <div className="login-heading">
          <span className="eyebrow">家庭空间</span>
          <h1 id="login-title">宝宝喂养工作台</h1>
          <p>输入家庭 Key</p>
        </div>
        <form className="login-form" onSubmit={submit}>
          <label className="field field--large">
            <span>工作台 Key</span>
            <span className="input-with-icon">
              <KeyRound size={19} aria-hidden="true" />
              <input
                type="password"
                autoComplete="current-password"
                value={key}
                onChange={(event) => setKey(event.target.value)}
                placeholder="至少 6 个字符"
                minLength="6"
                autoFocus
                required
              />
            </span>
          </label>
          <label className="check-row">
            <input type="checkbox" checked={remember} onChange={(event) => setRemember(event.target.checked)} />
            <span>在这台设备上记住 Key</span>
          </label>
          {error ? <p className="form-error" role="alert">{error}</p> : null}
          <button className="button button--primary button--large button--full" type="submit" disabled={busy || key.trim().length < 6}>
            <LockKeyhole size={19} />
            {busy ? '正在连接家庭空间…' : '打开工作台'}
          </button>
        </form>
        <p className="login-footnote">Key 不会写入宝宝记录；不同 Key 的数据彼此隔离。</p>
      </section>
    </main>
  );
}
